import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  const { t } = useTranslation();

  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            {t('categories.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3" data-product-shop>
          {categories.map((cat) => (
            <button
              key={cat.nameKey}
              onClick={() => handleClick(cat.url)}
              className="group relative flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300 hover:bg-background-50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center group-hover:bg-accent-100 transition-colors">
                <i className="ri-shopping-bag-3-line text-secondary-600 group-hover:text-accent-600 text-xl transition-colors"></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 text-center whitespace-nowrap">
                {t(cat.nameKey)}
              </span>
              <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-accent-500 text-xs absolute top-3 right-3 transition-colors"></i>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}